import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import {
  Grid,
  Box,
  Zoom,
  TableCell,
} from "@mui/material";
import { Button as PrimeButton } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { MultiSelect } from 'primereact/multiselect';
import { formatValue, formatTokenLabel, formatBalanceWithIcon, formatPercentage, formatTokenLabelExtended } from "../../utils";
import ReactSelect from "react-select";
import Web3 from "web3";
import { Message } from 'primereact/message';
import { Skeleton } from 'primereact/skeleton';

import { useWeb3React } from "@web3-react/core";
import ContractContext from '../../ContractContext';
import TokenSlider from "./TokenSlider";
import makeAnimated from "react-select/animated";
import { Text } from '@nextui-org/react';
import { Progress } from '@nextui-org/react';

import { Toast } from 'primereact/toast';

import { Table } from '@nextui-org/react';
import AddReward from "./AddReward";


import {
  cardStyleSmartRewards
} from "./TileStyles";

import RewardPacksModuleProfile from "./RewardPacksModuleProfile";


const RewardsPackSelector = React.memo(({ data, getData }) => {

  const { library, account } = useWeb3React();
  const contractContext = useContext(ContractContext);
  const contracts = contractContext.contracts;
  const isWalletConnected = () => account !== null;

  const toast = useRef(null);

  const LoadingContent = () => <Skeleton width="50%" height="35px" className="mb-2" />;
  const LoadingTitle = () => <Skeleton width="25%" height="25px" className="mb-2" />;

  const [selectedTokens, setSelectedTokens] = useState([]);
  const [tokenWeights, setTokenWeights] = useState({});
  const [isApplyingProfile, setIsApplyingProfile] = useState(false);
  const [isResyncingShares, setIsResyncingShares] = useState(false);
  const [currentProfile, setCurrentProfile] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const isInCoolDown = useCallback(async () => {
    const result = await contracts.rp_rewardPacks.methods.isInCoolDown(account).call();;
    //console.log("cooldown:", result);
    return result;
  }, [contracts.rp_rewardPacks]);

  const [cooldownStatus, setCooldownStatus] = useState(false);

  useEffect(() => {
    if (!account) return;
    isInCoolDown().then((result) => {
      setCooldownStatus(result);
    });
  }, [account, isInCoolDown]);

  useEffect(() => {
    let initialWeights = {};
    selectedTokens.forEach((token) => {
      initialWeights[token] = 0;
    });
    setTokenWeights(initialWeights);
  }, [selectedTokens]);

  useEffect(() => {
    //console.log("data:", data);
    //build the current profile by searching through data.tokenPoolDataRp._poolID and data.tokenPoolDataRp._holderPoolShares by what poolID's are in data.contractDataRp.smartData.subscriptionPools (Array of poolIDs)
    //the current profile should "poolID" or "tokenAddress" : "weight"
    if (!data?.contractDataRp?.smartData?.subscriptionPools) return;
    let _currentProfile = {};
    data.contractDataRp.smartData.subscriptionPools.forEach(poolID => {
      let token = data.tokenPoolDataRp.find(pool => pool._poolID === poolID);
      let tokenAddress = token?._tokenAddress.toLowerCase();
      let weight = token?._holderPoolShares;
      _currentProfile[tokenAddress] = weight;
    });
    setCurrentProfile(_currentProfile);

  }, [data]);

  useEffect(() => {
    if (!currentProfile) return;
    //console.log("currentProfile:", currentProfile);
    // let _selectedTokens = [];
    // let _tokenWeights = {};
    // Object.entries(currentProfile).forEach(([tokenAddress, weight]) => {
    //   let token = data.tokensListRp.find(token => token.value === tokenAddress);
    //   _selectedTokens.push(token);
    //   _tokenWeights[tokenAddress] = weight;
    // });
    // setSelectedTokens(_selectedTokens);
    // setTokenWeights(_tokenWeights);
  }, [currentProfile]);

  const handleTokenSelection = (event) => {
    const newSelectedTokens = event.map((item) => ({
      value: item.value,
      label: item.label,
      name: item.name
    }));

    // Initialize newTokenWeights with the current tokenWeights
    let newTokenWeights = { ...tokenWeights };

    // Calculate the remaining weight and the number of new tokens added
    let remainingWeight = 100 - Object.values(newTokenWeights).reduce((a, b) => a + b, 0);
    let newTokensCount = 0;
    for (const token of newSelectedTokens) {
      if (!selectedTokens.includes(token)) {
        newTokensCount++;
      }
    }

    // If there are new tokens, update the weights
    if (newTokensCount > 0) {
      const newTokenWeight = remainingWeight / newTokensCount;

      for (const token of newSelectedTokens) {
        if (!selectedTokens.includes(token)) {
          newTokenWeights[token] = newTokenWeight;
        }
      }
    } else {
      // If there are no new tokens, remove the unselected tokens from newTokenWeights
      for (const token of selectedTokens) {
        if (!newSelectedTokens.includes(token)) {
          remainingWeight += newTokenWeights[token];
          delete newTokenWeights[token];
        }
      }

      // Distribute the remaining weight among the remaining tokens
      const remainingTokensCount = newSelectedTokens.length;
      if (remainingTokensCount > 0) {
        const additionalWeightPerToken = remainingWeight / remainingTokensCount;

        for (const token of newSelectedTokens) {
          newTokenWeights[token] += additionalWeightPerToken;
        }
      }
    }

    setSelectedTokens(newSelectedTokens);
    setTokenWeights(newTokenWeights);
  };

  // const handleTokenSelection = (event) => {
  //   // Create a new array of selected tokens from the event
  //   const newSelectedTokens = event.map((item) => ({
  //     value: item.value,
  //     label: item.label,
  //   }));

  //   // Initialize newTokenWeights with the current tokenWeights
  //   let newTokenWeights = { ...tokenWeights };

  //   // Remove weights of tokens that are no longer selected
  //   Object.keys(newTokenWeights).forEach((token) => {
  //     if (!newSelectedTokens.some((selectedToken) => selectedToken.value === token)) {
  //       delete newTokenWeights[token];
  //     }
  //   });

  //   // If there are new tokens, add them with an initial weight
  //   newSelectedTokens.forEach((token) => {
  //     if (!tokenWeights.hasOwnProperty(token.value)) {
  //       newTokenWeights[token.value] = 0; // Assign initial weight, you can adjust this logic as needed
  //     }
  //   });

  //   // Update states
  //   setSelectedTokens(newSelectedTokens);
  //   setTokenWeights(newTokenWeights);
  // };

  const handleSliderChange = (token, newValue) => {
    setTokenWeights((prevWeights) => ({ ...prevWeights, [token]: newValue }));
  };

  const getRemainingWeight = () => {
    return 100 - Object.values(tokenWeights).reduce((a, b) => a + b, 0);
  };


  const handleMigration = async () => {
    setIsResyncingShares(true);
    if (!isWalletConnected()) {
      console.error("Please connect to a wallet before interacting with the contract.");
      toast.current.show({ severity: 'error', summary: 'Wallet Error', detail: 'Please connect to a wallet before interacting with the contract.', life: 3000 });
      return;
    }

    if (!contracts.rp_resyncShares) {
      console.error("Smart rewards contract not available.");
      toast.current.show({ severity: 'error', summary: 'Contract Error', detail: 'Smart rewards contract not available.', life: 3000 });
      return;
    }

    try {

      const transaction = contracts.rp_resyncShares.methods.migrate().send({ from: account });

      transaction.on("transactionHash", (hash) => {
        toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
      });

      const tx = await transaction;

      toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });



    } catch (error) {
      console.error("Error interacting with the Reward Packs contract:", error);
      toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Reward Packs contract: ${error.message}`, life: 3000 });
    }
    getData();
    setIsResyncingShares(false);
  };

  const handleSetProfileByTokens = async () => {
    setIsApplyingProfile(true);
    if (!isWalletConnected()) {
      console.error("Please connect to a wallet before interacting with the contract.");
      toast.current.show({ severity: 'error', summary: 'Wallet Error', detail: 'Please connect to a wallet before interacting with the contract.', life: 3000 });
      return;
    }

    if (!contracts.rp_rewardPacks) {
      console.error("Smart rewards contract not available.");
      toast.current.show({ severity: 'error', summary: 'Contract Error', detail: 'Smart rewards contract not available.', life: 3000 });
      return;
    }
    // console.log("selectedTokens:", selectedTokens);
    // console.log("length:", selectedTokens.length);
    // console.log("tokenWeights:", tokenWeights);
    // console.log("length:", Object.keys(tokenWeights).length);

    const sumOfWeights = Object.values(tokenWeights).reduce((a, b) => a + b, 0);

    if (sumOfWeights !== 100) {
      toast.current.show({ severity: 'error', summary: 'Weight Error', detail: `The sum of the token weights must be equal to 100%. Please adjust the weights accordingly.`, life: 3000 });
      return;
    }

    // Check if any selected token has a weight of zero
    if (selectedTokens.length !== Object.keys(tokenWeights).length - 1) {
      toast.current.show({ severity: 'error', summary: 'Weight Error', detail: `Please set a weight for each token.`, life: 3000 });
      return;
    }

    for (let token of selectedTokens) {
      if (tokenWeights[token.value] === 0) {
        toast.current.show({ severity: 'error', summary: 'Weight Error', detail: `Token ${token.label} has a weight of 0. Please adjust its weight before proceeding.`, life: 3000 });
        return;
      }
    }

    // Scale the token weights by 1000 and filter out tokens with 0 weight
    const scaledTokenWeights = Object.entries(tokenWeights).reduce((acc, [key, value]) => {
      if (value !== 0) {
        acc[key] = value * 100;
      }
      return acc;
    }, {});

    try {
      const tokens = selectedTokens.map(tokenObj => tokenObj.value);
      const subscriptions = Object.values(scaledTokenWeights);

      const transaction = contracts.rp_rewardPacks.methods.subscribeToSmartProfile(tokens, subscriptions).send({ from: account });

      transaction.on("transactionHash", (hash) => {
        toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
      });

      const tx = await transaction;

      toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });



    } catch (error) {
      console.error("Error interacting with the Reward Packs contract:", error);
      toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Reward Packs contract: ${error.message}`, life: 3000 });
    }
    getData();
    setIsApplyingProfile(false);
  };


  const calculateTotalWeight = () => {
    if (!currentProfile) return 1;
    let totalWeight = 0;
    Object.values(currentProfile).forEach(weight => {
      totalWeight += parseFloat(weight);
    });
    //console.log('totalWeight: ', totalWeight);
    return totalWeight;
  };


  return (
    <div style={
      {
        ...cardStyleSmartRewards,
        minHeight: "300px",
        marginTop: "20px",
      }
    }>

      <div>

        {/* <Box
    sx={{
      width: "100%",
      paddingBottom: selectedTokens.length === 0 ? "2rem" : "0",
    }}
  > */}
        <RewardPacksModuleProfile data={data} getData={getData} currentProfile={currentProfile} />
        {calculateTotalWeight() == 0 && <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          {isResyncingShares ? <div style={{ width: '200px', justifyContent: 'center', marginTop: '25px', marginBottom: '25px' }}><Progress
            indeterminated
            color="gradient"
            status="secondary"
            size="xl"

          /></div> : <>
            {<PrimeButton
              rounded
              severity="warning"
              size="small"
              style={{ width: '200px', justifyContent: 'center', marginTop: '25px', marginBottom: '25px' }}
              onClick={handleMigration}
              enabled
            >
              Migrate Reward Pack
            </PrimeButton>}
          </>}
        </Box>}
        <div className="token-selection">
          {/* need this component to have black background and white text */}

          {/* <MultiSelect
value={selectedTokens}
options={data?.tokensListRp}
onChange={(e) => handleTokenSelection2(e.value)}
optionLabel="label"
placeholder="Select Tokens..."
itemTemplate={(option) => formatTokenLabel(data?.dbData, { value: option.value, label: option.label })}
style={{ borderRadius: '10px', backgroundColor: 'black', color: 'white' }}
filter 
/> */}

          <ReactSelect
            isMulti
            id="token-selection"
            options={data?.tokensListRp?.map(token => ({
              value: token.value,
              label: token.label,
              name: token.name  // Ensure this field is correctly mapped
            })).sort((a, b) => a.label.localeCompare(b.label))}
            value={selectedTokens}
            onChange={handleTokenSelection}
            components={makeAnimated()}
            //className="token-select"
            placeholder="Search for Tokens..."

            formatOptionLabel={(option) => formatTokenLabelExtended(data?.dbData, { value: option.value, label: option.label, name: option.name })}
            filterOption={(option, searchText) => {
              const searchCriteria = `${option.data.label.toLowerCase()} ${option.data.value.toLowerCase()} ${option.data.name.toLowerCase()}`;
              return searchCriteria.includes(searchText.toLowerCase());
            }}

            //we want border radius to be 10px

            styles={{
              container: (provided, state) => ({
                ...provided,
                background: "#333333",
                border: "none",
                borderRadius: "20px",
                boxShadow: "none",
                color: "white",
                fontFamily: "Inter, sans-serif",
                fontSize: "16px",
                fontWeight: "500",
                minHeight: "48px",
                //padding: "0.5rem",
                "&:hover": {
                  borderColor: "#333333",
                },
              }),
              control: (provided, state) => ({
                ...provided,
                //background: "#333333",
                border: "none",
                borderRadius: "40px",
                boxShadow: "none",
                color: "white",
                fontFamily: "Inter, sans-serif",
                fontSize: "16px",
                fontWeight: "500",
                minHeight: "48px",
                padding: "0.5rem",
                //marginBottom: "0",
                //paddingBottom: "0",
                "&:hover": {
                  borderColor: "#333333",
                },
              }),
              menu: (provided, state) => ({
                ...provided,
                background: "white",
                //border: "none",
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
                boxShadow: "none",
                color: "#333333",
                fontFamily: "Inter, sans-serif",
                fontSize: "16px",
                fontWeight: "500",
                padding: "0.5rem",
                marginTop: "0px",
                //ensure its at the top of all other elements
                zIndex: "1000",
                //thin grey border
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "#333333",
              }),
              // option: (provided, state) => ({
              //   ...provided,
              //   background: state.isFocused ? "#333333" : "#333333",
              //   color: state.isFocused ? "white" : "white",
              //   fontFamily: "Inter, sans-serif",
              //   fontSize: "16px",
              //   fontWeight: "500",
              //   padding: "0.5rem",
              // }),
              multiValue: (provided, state) => ({
                ...provided,
                background: "#333333",
                color: "white",
                fontFamily: "Inter, sans-serif",
                fontSize: "16px",
                fontWeight: "500",
                padding: "0.15rem",
                borderRadius: "20px",
              }),
              multiValueLabel: (provided, state) => ({
                ...provided,
                color: "white",
                fontFamily: "Inter, sans-serif",
                fontSize: "16px",
                fontWeight: "700",
              }),
              multiValueRemove: (provided, state) => ({
                ...provided,
                color: "white",
                fontFamily: "Inter, sans-serif",
                fontSize: "16px",
                fontWeight: "500",
                borderRadius: "20px",
                "&:hover": {
                  color: "white",
                  cursor: "pointer",
                },
              }),
              indicatorSeparator: (provided, state) => ({
                ...provided,
                background: "#333333",
              }),
              dropdownIndicator: (provided, state) => ({
                ...provided,
                color: "#333333",
                "&:hover": {
                  color: "#333333",
                },
              }),
              clearIndicator: (provided, state) => ({
                ...provided,
                color: "#333333",
                "&:hover": {
                  color: "#333333",
                },
              }),
              placeholder: (provided, state) => ({
                ...provided,
                color: "#333333",
              }),
              input: (provided, state) => ({
                ...provided,
                color: "#333333",
              }),

            }}
          />
        </div>
        <div style={{
          marginTop: "15px",
        }} >
          <div className="slider-container">
            <Grid container spacing={2}>
              {selectedTokens.map((token, index) => {
                const fullTokenData = data?.tokensListRp?.find(
                  (t) => t.value === token.value
                );

                return (
                  // <Grid item key={token.value} xs={12} sm={6} md={4} lg={3} xl={2}>
                  <Grid item key={token.value} xs={12} sm={"auto"} md={"auto"} lg={"auto"} xl={"auto"}>
                    <Zoom in={true} style={{ transitionDelay: index * 50 }}>
                      <Box sx={{ mt: 0.5, mb: 0.5 }}>
                        <TokenSlider
                          token={token}
                          //rocketFiSubscribed={
                          //   fullTokenData.rocketFiSubscribed
                          // }
                          //totalDistributed={
                          //   fullTokenData.totalDistributed
                          // }
                          //decimals={fullTokenData.decimals}
                          weight={tokenWeights[token.value] || 0}
                          maxWeight={
                            (tokenWeights[token.value] || 0) +
                            getRemainingWeight()
                          }
                          onChange={(event, newValue) =>
                            handleSliderChange(token.value, newValue)
                          }

                          label={formatTokenLabel(data?.dbData, token)}
                        />
                      </Box>
                    </Zoom>
                  </Grid>
                );
              })}
            </Grid>
          </div>

        </div>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>

          {
            cooldownStatus &&
            <>
              <Message
                severity="warn"
                text={"You are in cooldown. Please wait for the cooldown period to end before changing reward pack."}
              />


            </>
          }
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          {isApplyingProfile ? <div style={{ width: '200px', justifyContent: 'center', marginTop: '25px', marginBottom: '25px' }}><Progress
            indeterminated
            color="gradient"
            status="secondary"
            size="xl"

          /></div> : <>
            {<PrimeButton
              rounded
              severity="warning"
              size="small"
              style={{ width: '200px', justifyContent: 'center', marginTop: '25px', marginBottom: '25px' }}
              onClick={handleSetProfileByTokens}
              disabled={(selectedTokens.length === 0 && selectedTokens.length <= 10) || getRemainingWeight() !== 0 || calculateTotalWeight() == 0 || cooldownStatus ? true : false}
            >
              Update Reward Pack
            </PrimeButton>}
          </>}
        </Box>
        {/* </Box> */}
      </div>


      <Toast ref={toast} />

    </div>
  );
});


export default RewardsPackSelector;




// const [clickedRow, setClickedRow] = useState(null);

// const handleRowClick = (token) => {
//   if (!selectedTokens.find((selectedToken) => selectedToken.value === token.value)) {
//     setSelectedTokens((prevSelectedTokens) => [...prevSelectedTokens, token]);
//   }
//   setClickedRow(token.value);
//   resetClickedRow();
// };

// const resetClickedRow = () => {
//   setTimeout(() => {
//     setClickedRow(null);
//   }, 200);
// };

// const CustomTableCell = (props) => {
//   return (
//     <TableCell {...props} sx={{ padding: "8px", ...props.sx }}>
//       {props.children}
//     </TableCell>
//   );
// };